import { Directive, ElementRef, Renderer2, HostListener, OnInit, Output, HostBinding } from '@angular/core';
import { EventEmitter } from '@angular/core';


enum KeyPress {
  Enter = 13,
  Space = 32
}

@Directive({
  selector: '[oirTabbable]'
})
export class TabbableDirective implements OnInit {

  @Output() readonly action: EventEmitter<any> = new EventEmitter<any>();

  @HostBinding('class.customTabs') customTabs = true;

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    if (event.which === KeyPress.Enter ||  event.which === KeyPress.Space) {
      this.action.emit(event);
    }
  }

  @HostListener('click', ['$event']) onClick(event): void {
    this.action.emit(event);
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit(): void {
    this.renderer.setProperty(this.el.nativeElement, 'tabIndex', '0');
  }

}
